import React, { Component } from 'react'
import Grid from '@material-ui/core/Grid'
import { makeStyles } from '@material-ui/core/styles'

import { connect } from 'react-redux'
import { uploadS3ZoomProgress } from '../../actions/'

import Button from '@material-ui/core/Button'

import DescriptionIcon from '@material-ui/icons/Description'
import BrowserStore from 'store'

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 200
  },

  chip: {
    margin: theme.spacing(0.5)
  }
}))

class UploadS3 extends Component {
  render() {
    const { data, uploadRequest } = this.props

    return (
      <React.Fragment>
        <Grid container spacing={3}>
          <div>
            <ul>
              <li>
                Review
                <ul>
                  {data.isSingleCourse === true ? (
                    <li>Course ID: {data.courseId}</li>
                  ) : (
                    <li>Course IDs: {data.courseIds.join(', ')}</li>
                  )}

                  <li>Requested By: {data.requestedBy} </li>

                  {data.isSingleCourse === true ? (
                    <li>Selected Days: {data.daysCount} </li>
                  ) : null}
                </ul>
              </li>
            </ul>
          </div>
        </Grid>
      </React.Fragment>
    )
  }
}

const mapStateToProps = (state) => ({
  data: state.Zoom
})
const mapDispatchToProps = (dispatch) => ({
  uploadRequest: (status) => {
    dispatch(uploadS3ZoomProgress(status))
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(UploadS3)
